module.exports = __webpack_public_path__ + "static/media/effe.df63c2ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ContactUs/static/images/brands/effe.png
// module id = 68
// module chunks = 1